import { useEffect, useState } from "react";

interface Props {
  show: boolean;
  onDone?: () => void;
}

export function ExplosionOverlay({ show, onDone }: Props) {
  const [shards, setShards] = useState<{ tx: number; ty: number; delay: number }[]>([]);

  useEffect(() => {
    if (!show) return;
    const arr: { tx: number; ty: number; delay: number }[] = [];
    for (let i = 0; i < 40; i++) {
      const angle = Math.random() * Math.PI * 2;
      const dist = 180 + Math.random() * 260;
      arr.push({
        tx: Math.cos(angle) * dist,
        ty: Math.sin(angle) * dist + Math.random() * 40,
        delay: Math.random() * 0.08,
      });
    }
    setShards(arr);
    const t = setTimeout(() => onDone?.(), 900);
    return () => clearTimeout(t);
  }, [show, onDone]);

  if (!show) return null;
  return (
    <>
      <div className="explosion-flash" />
      <div className="fixed inset-0 pointer-events-none z-[60]">
        {shards.map((s, i) => (
          <span
            key={i}
            className="explosion-shard"
            style={{
              ["--tx" as any]: `${s.tx}px`,
              ["--ty" as any]: `${s.ty}px`,
              animationDelay: `${s.delay}s`,
            }}
          />
        ))}
      </div>
    </>
  );
}
